import { styled } from '@mui/material/styles';

const PREFIX = 'ErrorComponent';

export const classes = {
  root: `${PREFIX}-root`,
  main: `${PREFIX}-main`,
  header: `${PREFIX}-header`,
  container: `${PREFIX}-container`,
  content: `${PREFIX}-content`,
  margin: `${PREFIX}-margin`,
  fontLarge: `${PREFIX}-fontLarge`,
};

export const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    backgroundColor: 'white',
    height: '100%',
  },

  [`& .${classes.main}`]: {
    padding: theme.spacing(4),
  },

  [`& .${classes.header}`]: {
    padding: theme.spacing(4),
    borderBottom: `2px solid ${theme.palette.primary.main}`,
  },

  [`& .${classes.container}`]: {
    padding: theme.spacing(10, 4),
    width: '100%',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },

  [`& .${classes.content}`]: {
    textAlign: 'center',
  },

  [`& .${classes.margin}`]: {
    marginTop: 30,
  },

  [`& .${classes.fontLarge}`]: {
    fontSize: 60,
  },
}));
